module.exports = __webpack_public_path__ + "img/target.33c8e96e.png";